module.exports = __webpack_public_path__ + "static/mobile-hosting-a9a71483eaaf8476415d404f62c4c2a3.png";